import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { User } from 'projects/core/src/lib/login/data/user';
import { AppStateQuery } from 'projects/desktop/src/app/data/app-state.query';
import { AppStateStore } from 'projects/desktop/src/app/data/app-state.store';
import { TimeCardsStore } from '../../data/time-cards.store';
import { TimeCardsQuery } from '../../data/time-cards.query';
import * as moment from 'moment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Project } from '../../../project-misc/data/project/project';
import { TimeCardService } from '../../data/time-card.service';

@Component({
    selector: 'app-punch-widget-dialog',
    templateUrl: './punch-widget-dialog.component.html',
    styleUrls: ['./punch-widget-dialog.component.scss'],
    providers: [DeviceDetectorService]
})
export class PunchWidgetDialogComponent implements OnInit, OnDestroy {
    currentUser = this.appStateQuery.currentUser$;
    punchedIn: boolean;

    totalTime = '';

    breakType = 'WORK';

    startDay = moment().format('YYYY-MM-DD');

    startWeek = moment().startOf('week').format('YYYY-MM-DD');
    endWeek = moment().endOf('week').format('YYYY-MM-DD');

    startPayPeriod: string;
    endPayPeriod: string;

    deviceInfo = null;
    isDesktop: boolean;
    isTablet: boolean;
    isMobile: boolean;

    showProjectsPage: boolean;

    weekTotalTime: number;
    weekTotalTimeStr: string;

    constructor(
        private deviceService: DeviceDetectorService,
        protected appStateQuery: AppStateQuery,
        protected appStateStore: AppStateStore,
        protected timeCardsStore: TimeCardsStore,
        protected timeCardsQuery: TimeCardsQuery,
        protected timeCardService: TimeCardService,
    ) {
    }

    ngOnInit() {
        this.detectDevice();

        this.timeCardsQuery.breakType$.subscribe(type => {
            if (type !== null) {
                this.breakType = type;
            }
        })


        this.timeCardsQuery.weekTotalTime$.subscribe(time => {
            this.weekTotalTime = time
            this.countTime();
        });


        // this.timeCardService.getBatchCards(this.startWeek, this.endWeek).subscribe(cards => {
        // 	console.log(cards)
        // })
    }

    countTime() {
        const totalHours = Math.trunc(this.weekTotalTime / 60)
        const totalMinutes = Math.trunc(this.weekTotalTime - totalHours * 60)
        this.weekTotalTimeStr = totalHours + 'h ' + totalMinutes + 'm'
    }


    ngOnDestroy() {
    }

    toggleProjectsPage() {
        this.showProjectsPage = true;
    }

    detectDevice() {
        this.deviceInfo = this.deviceService.getDeviceInfo();
        if (this.deviceService.isMobile()) {
            this.isMobile = true;
        }
        if (this.deviceService.isTablet()) {
            this.isTablet = true;
        }
        if (this.deviceService.isDesktop()) {
            ;
            this.isDesktop = true;
        }
    }

    projectIsChoosen(event: Project) {
        if (event) {
            this.timeCardsStore.updateChoosenProject(event);
            this.timeCardService.projectChanger.next(event)
        }

        this.showProjectsPage = false;
    }


}
